import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../common-components/CommonStructured";
import {
  fetchDiscountPaymentsData,
  fetchDiscountPaymentsRequestsData,
  fetchPT_DiscountPaymentLinksData,
  fetchPT_DiscountPaymentsRequestsData,
} from "../../redux/payment-reducerss/paymentSlice";
import UserDetails from "../deffered-payments/UserDetails";
import DPListings from "./DPListings";
import CmnFilters from "../lead-management/common/CmnFilters";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import Notifications from "../push-notifications/Notifications";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import DPApproval from "./DPApproval";
import ViewDetails from "./ViewDetails";
import PartialDetails from "../upgrade-membership/PartialDetails";
import {
  fetchDiscountApprovalAccessData,
  fetchDiscountPaymentCreationData,
} from "../../redux/prospect-reducers/prospectSlice";
import DPFDCreationForm from "./fd-creation-toggle/DPFDCreationForm";
import { isManagerRole as checkIsManagerRole } from "../common-data/Conversions";

const DPStructure = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");

  const { postPutLoading } = useSelector((state) => state.common);
  const { fdDiscountPaymentEnableLoading, fdDiscountPaymentEnable } =
    useSelector((state) => state.prospects);

  const {
    discountPaymentsLoading,
    discountPaymentRequestsLoading,
    ptDiscountPaymentRequestsLoading,
    ptDiscountPaymentsLoading,
  } = useSelector((state) => state.payment);
  const { postPutLoading1 } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = checkIsManagerRole(userInfoData);

  const [selectedTab, setSelectedTab] = useState(0);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selAddedby:
      !isAdmin && !isManagerRole
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    isActive: "",
    selectedPlanType: "",
    selectedPlan: "",
    selectedGender: "",
    selectedIsApproved: "",
    selectedApprovalManager: "",
    selectedPaymentModes: "",

    selectedExperienceLevel: "",
    selectedPaymentLocation: "",
    selLeadSource: "",

    selectedStartDate: "",
    selectedEndDate: "",
    searchString: "",

    selectedWapSent: "",
    selectedWapDelivered: "",
    selectedWapRead: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    type: "custom",
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    created_by: allFilters.selAddedby?.value || "",
    status: allFilters.isActive?.value || "",
    approval_status: allFilters.selectedIsApproved?.value || "",
    plan_duration: allFilters.selectedPlan?.value || "",
    gender: allFilters.selectedGender?.value || "",
    aprv_rej_by: allFilters.selectedApprovalManager?.value || "",
    payment_mode: allFilters.selectedPaymentModes?.value || "",
    experience_level: allFilters.selectedExperienceLevel?.value || "",
    payment_location: allFilters.selectedPaymentLocation?.value || "",
    lead_source: allFilters.selLeadSource?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    uid: uid || "",
    wap_sent: allFilters.selectedWapSent?.value || "",
    wap_delivered: allFilters.selectedWapDelivered?.value || "",
    wap_read_status: allFilters.selectedWapRead?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const [showUserInfoForm, setShowUserInfoForm] = useState(false);
  const [isFdEnable, setIsFdEnable] = useState(null);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    isOnlyViewDetails: false,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  const onCloseModal = () => {
    setModValues(iniModValues);

    if (modValues.modName === "view_details" && modValues.isOnlyViewDetails) {
      setFilters((prevs) => {
        const { uid, ...updatedFilters } = prevs;
        return updatedFilters;
      });
      navigate("/discount-payments");
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setShowUserInfoForm(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getFDDFPaymentsData(filters = {}) {
    dispatch(
      fetchDiscountPaymentCreationData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDiscountPaymentsRequests(filters) {
    const { type, status, wap_sent, wap_delivered, wap_read_status, ...rest } =
      filters || {};

    dispatch(
      fetchDiscountPaymentsRequestsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getPTDPRequests(filters) {
    const {
      type,
      status,
      plan_duration,
      wap_sent,
      wap_delivered,
      wap_read_status,
      ...rest
    } = filters || {};

    dispatch(
      fetchPT_DiscountPaymentsRequestsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getDiscountPayments(filters) {
    const { approval_status, aprv_rej_by, ...rest } = filters || {};

    dispatch(
      fetchDiscountPaymentsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getPTDiscountPayments(filters) {
    const { type, approval_status, aprv_rej_by, plan_duration, ...rest } =
      filters || {};

    dispatch(
      fetchPT_DiscountPaymentLinksData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getApprovalManagers() {
    if (userInfoData?.email && userInfoData?.token) {
      dispatch(
        fetchDiscountApprovalAccessData({
          filters: { email: userInfoData.email },
          token: userInfoData.token,
        })
      );
    }
  }

  function getCall() {
    getDiscountPayments(filters);
    getDiscountPaymentsRequests(filters);

    getPTDPRequests(filters);
    getPTDiscountPayments(filters);

    getFDDFPaymentsData();

    getApprovalManagers();
  }

  useEffect(() => {
    getFDDFPaymentsData();
    getApprovalManagers();
  }, []);

  useEffect(() => {
    if (fdDiscountPaymentEnable?.status && fdDiscountPaymentEnable?.data) {
      setIsFdEnable(fdDiscountPaymentEnable.data);
    } else {
      setIsFdEnable(null);
    }
  }, [fdDiscountPaymentEnable]);

  useEffect(() => {
    getDiscountPaymentsRequests(filters);
    getPTDPRequests(filters);
  }, [
    filters.page,
    filters.limit,
    filters.gym_id,
    filters.created_by,
    filters.approval_status,
    filters.plan_duration,
    filters.gender,
    filters.aprv_rej_by,
    filters.payment_mode,
    filters.start_date,
    filters.end_date,
    filters.uid,
    filters.search,
    filters.lead_source,
  ]);

  useEffect(() => {
    getDiscountPayments(filters);
    getPTDiscountPayments(filters);
  }, [
    filters.type,
    filters.page,
    filters.limit,
    filters.gym_id,
    filters.created_by,
    filters.status,
    filters.plan_duration,
    filters.gender,
    filters.payment_mode,
    filters.start_date,
    filters.end_date,
    filters.search,
    filters.lead_source,
    filters.wap_sent,
    filters.wap_delivered,
    filters.wap_read_status,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      created_by: allFilters.selAddedby?.value || "",
      status: allFilters.isActive?.value || "",
      approval_status: allFilters.selectedIsApproved?.value || "",
      type: allFilters.selectedPlanType?.value || "",
      plan_duration: allFilters.selectedPlan?.value || "",
      gender: allFilters.selectedGender?.value || "",
      aprv_rej_by: allFilters.selectedApprovalManager?.value || "",
      payment_mode: allFilters.selectedPaymentModes?.value || "",
      experience_level: allFilters.selectedExperienceLevel?.value || "",
      payment_location: allFilters.selectedPaymentLocation?.value || "",
      lead_source: allFilters.selLeadSource?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      wap_sent: allFilters.selectedWapSent?.value || "",
      wap_delivered: allFilters.selectedWapDelivered?.value || "",
      wap_read_status: allFilters.selectedWapRead?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.isActive,
    allFilters.selectedIsApproved,
    allFilters.selectedPlanType,
    allFilters.selectedPlan,
    allFilters.selectedGender,
    allFilters.selectedApprovalManager,
    allFilters.selectedPaymentModes,
    allFilters.selectedExperienceLevel,
    allFilters.selectedPaymentLocation,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selLeadSource,
    allFilters.selectedWapSent,
    allFilters.selectedWapDelivered,
    allFilters.selectedWapRead,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Discount Payments">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div className={`createNewCTOModalContainer mod-width-50p`}>
            {modValues.modName !== "fd_creation" &&
              modValues.modName !== "cm_creation" && (
                <ModalHeadAndClose
                  title={
                    modValues.modName === "remarks"
                      ? `${modValues.rowData?.status?.replace(
                          /_/g,
                          " "
                        )} Remarks`
                      : modValues.modName === "approval"
                      ? "Approve/Reject Discount Payment Request"
                      : modValues.modName?.replace(/_/g, " ")
                  }
                  onClose={onCloseModal}
                />
              )}

            {modValues.modName === "approval" ? (
              <DPApproval
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                callFunction={() => {
                  getCall();

                  if (uid) {
                    setFilters((prevs) => {
                      const { uid, ...updatedFilters } = prevs;
                      return updatedFilters;
                    });

                    navigate("/discount-payments");
                  }
                }}
                onCloseModal={onCloseModal}
              />
            ) : modValues.modName === "remarks" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.aprv_rej_remarks ||
                    modValues.rowData?.cm_aprv_rej_remarks ||
                    "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "view_details" ? (
              <ViewDetails rowData={modValues.rowData} isDP={true} />
            ) : modValues.modName === "partial_details" ? (
              <PartialDetails
                tbData={modValues.rowData?.partial_payment_details || []}
                isDF={true}
              />
            ) : modValues.modName === "fd_creation" ||
              modValues.modName === "cm_creation" ? (
              <DPFDCreationForm
                userInfoData={userInfoData}
                callFunction={() => getFDDFPaymentsData()}
                closeModal={onCloseModal}
                isFdEnable={isFdEnable}
                modName={modValues.modName}
              />
            ) : null}
          </div>
        </Modal>

        {isCustom && (
          <Row>
            <Col>
              <WelcomeUser userName={userInfoData?.name} />

              {userInfoData && !isIOS() && (
                <Notifications authData={userInfoData} />
              )}

              {/* {isNotificationDenied === "denied" && (
                <Alert variant={"danger"} className="mt30">
                  Notification permission is denied. Unable to display desktop
                  notifications.
                </Alert>
              )} */}
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Discount Payments | Regular & PT"}
              createBtnTxt={
                isAdmin || isManagerRole
                  ? "+ Add New Payment"
                  : "← Request New Payment"
              }
              onClickCreateBtn={() => setShowUserInfoForm(true)}
              isReload={getCall}
              onClickBackBtn={isCustom ? handleBack : null}
              createBtnTxt1={isAdmin ? "+ FD Creation" : null}
              onClickCreateBtn1={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "fd_creation",
                }))
              }
              createBtnTxt2={isAdmin ? "+ CM Creation" : null}
              onClickCreateBtn2={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "cm_creation",
                }))
              }
              isLoading={postPutLoading || fdDiscountPaymentEnableLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <UserDetails
              decryptedText={userInfoData}
              callFunction={getCall}
              showUserInfoForm={showUserInfoForm}
              setShowUserInfoForm={setShowUserInfoForm}
              pageName="dp"
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="df"
              clickedCard="discount-payments"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={
                (discountPaymentsLoading &&
                  discountPaymentRequestsLoading &&
                  ptDiscountPaymentRequestsLoading &&
                  ptDiscountPaymentsLoading) ||
                postPutLoading1
              }
              selectedTab={selectedTab}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <DPListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              callFunction={getCall}
              userInfoData={userInfoData}
              setModValues={setModValues}
              uid={uid}
              setSelectedTab={setSelectedTab}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DPStructure;
